export const campoAtual = (state) => state.campoAtual
export const respostas = (state) => state.respostas || {}
export const revisao = (state) => state.revisao || 0
export const posicao = (state) => (state.posicao !== undefined ? state.posicao : null)
export const concluido = (state) => !!state.concluido
export const perguntas = (state) => state.perguntas || []
export const loading = (state) => !!state.loading
export const enviando = (state) => !!state.enviando
export const erro = (state) => state.erro || null

// ★ O agrupamento em etapas é do SERVIDOR (contracts/etapas-do-questionario.md) —
// estes dois só repassam o que veio. Lista vazia = o servidor ainda não manda; a tela
// não inventa etapa nenhuma nesse caso.
export const etapas = (state) => state.etapas || []
export const etapaAtual = (state) => state.etapaAtual || null

// Mapa `campo → texto` do que está sendo digitado AGORA (nunca gravado ainda).
export const rascunho = (state) => state.rascunho || {}

// A pergunta corrente completa (campo + rótulo + prefill), derivada de `perguntas` —
// a view nunca duplica a busca por `campo === campoAtual`.
export const perguntaCorrente = (state) => {
  const lista = state.perguntas || []
  return lista.find((pergunta) => pergunta.campo === state.campoAtual) || null
}
